import type { FileParameter, UploadSurvey2dType } from '@core/core/types'

export const toFile = (fileParameter: FileParameter) => fileParameter.data

export const convert2dSurveyData = ({
  files,
  name,
  domainType,
  coordsTemplates,
  projectId,
}: Omit<UploadSurvey2dType, 'fieldUid'>) => {
  if (coordsTemplates) {
    return {
      Files: files?.map(toFile) ?? [],
      Name: name,
      DomainType: domainType,
      'HeaderOffset.X': coordsTemplates.xOffset,
      'HeaderOffset.Y': coordsTemplates.yOffset,
      ProjectId: projectId,
    }
  }
  return {
    Files: files?.map(toFile) ?? [],
    Name: name,
    DomainType: domainType,
    ProjectId: projectId,
  }
}
